import React from 'react';
import { ProjectApprovalsTable } from 'features/project-approvals/ProjectApprovalsTable';
import { Header } from 'components/Header';
import { Grid } from 'components/UI/Grid';
import { useLanguage } from 'features/hooks/useLanguage';
import { LanguageType } from 'types/index';

const DICTIONARY = {
	[LanguageType.English]: {
		projectApprovals: 'Project Approvals'
	},
	[LanguageType.Norwegian]: {
		projectApprovals: 'Prosjektgodkjenninger'
	}
};

const EnterpriseAdminProjectApproval: React.FC = () => {
	const language = useLanguage();
	const dictionary = DICTIONARY[language];

	return (
		<div>
			<Header.Main />
			<Header.Navigation rightComponent={null} />
			<Header.Title title={dictionary.projectApprovals} />
			<Grid.Container>
				<ProjectApprovalsTable />
			</Grid.Container>
		</div>
	);
};

export default EnterpriseAdminProjectApproval;
